import React from 'react'
import { useState } from 'react'

type Props = {
  tabs: Array<{ title: string; content: React.ReactNode; slug: string }>
}

const Tabs = ({ tabs }: Props) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0].slug)

  return (
    <div>
      <div
        role='tablist'
        className='flex flex-row border-b-2 border-border-default bg-background-chrome md:w-1/2'
      >
        {tabs.map(tab => (
          <button
            type='button'
            key={`tab-${tab.slug}`}
            role='tab'
            aria-selected={selectedTab === tab.slug}
            className={`flex flex-1 justify-center border-b-2 p-4 transition-colors ${
              selectedTab !== tab.slug
                ? 'border-transparent text-text-primary hover:text-text-brand'
                : 'border-border-brand text-text-brand'
            }`}
            onClick={() => setSelectedTab(tab.slug)}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {tabs.map(tab => (
        <div
          key={`tab-content-${tab.slug}`}
          role='tabpanel'
          className={selectedTab === tab.slug ? '' : 'hidden'}
        >
          {tab.content}
        </div>
      ))}
    </div>
  )
}

export default Tabs
